module.exports = __webpack_public_path__ + "img/snow.fd5849dc.png";